export default __webpack_public_path__ + "static/media/login.2b5aac34.png";